import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// Redux Imports
import { useDispatch, useSelector } from 'react-redux';
import {
  studentDiscussionComments,
  // likeDislikeComment
} from '../../../actions/digitalDoubtActions';
import { openSnackBar } from '../../../actions/snackbarAction';
import PerfectScrollbar from 'react-perfect-scrollbar';
// Fetch
import { imagePost } from '../../../api/fetch';
// Material Imports
import { Avatar, IconButton, Dialog } from '@material-ui/core';
// Style
import './styles.scss';
// Global Components
// Icon
import CloseIcon from '@material-ui/icons/Close';
import LoadingGifIcon from '../../../assets/allen-ajax-loader.gif';
import AttachIcon from '../../../assets/attachment.svg';
import ClockIcon from '../../../assets/clock.png';
import SendIcon from '../../../assets/paperplane.svg';

import { insertCommentItem } from '../../../actions/teacherDigitalDoubtActions';
///signalR
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { HUB_BASE_URL } from '../../../api/fetch';

export const maxStudentDoubtCommentCount = 3;
var DFMIDOwnerReducer = "";

export default function DoubtComments(props) {
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [filePath, setFilePath] = useState('');
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [urlToExpand, seturlToExpand] = useState('');
  const [isSendingComment, setSendingComment] = useState(false);
  const [isImage, setIsImage] = React.useState(true);
  const [conn, setConn] = React.useState(null);
  const [state, setState] = useState({
    desc: '',
    image: '',
    uploadedImage: '',
    isFetching: false
  });
  

  // Redux
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', ''));
  const profileDetails = useSelector(state => get(state, 'loginReducer.data.profile', ''));
  const commentIndividual = useSelector(state =>
    get(state, 'digitalDoubtReducer.commentList')
  );

  const commentList = useSelector(state =>
    get(
      state,
      'digitalDoubtReducer.commentList.listComment',
      get(state, 'digitalDoubtReducer.commentList.listDiscussion', [])
    )
  );

  const AlwaysScrollToBottom = () => {
    const elementRef = useRef(null);
    useEffect(() => elementRef.current.scrollIntoView({}), [commentList]);
    return <div ref={elementRef} />;
  };
  
  const initialTotalSelfPost = useSelector(state =>
    get(state, 'digitalDoubtReducer.commentList.TotalSelfPost', 0)
  );

  const [totalSelfPost, setTotalSelfPost] = useState(0);
  
  useEffect(() => {
    DFMIDOwnerReducer = commentIndividual.DFMIDOwner;
  }, [commentIndividual]);

  useEffect(() => {
      console.log("initial self post");
      console.log(initialTotalSelfPost);
      
      setTotalSelfPost(initialTotalSelfPost);
  }, [initialTotalSelfPost]);

  

  const userType = useSelector(state =>
    get(state, 'loginReducer.userType', '')
  );

  useEffect(() => {
    fetchCommentData();
  }, []);

  useEffect(() => {
    setTimeout(() => {

    const url_endpoint = `${HUB_BASE_URL}${
      userType === 'student' ? 2 : 1
    }&forumID=${props.parentForumId}&token=${jwt}`;
    const connection = new HubConnectionBuilder()
    .withUrl(url_endpoint,{
      withCredentials:false
    })
      .configureLogging(LogLevel.Debug)
      .build();
    connection
      .start()
      .then(() => {
        
        //Used separate variables to create correct room ID
        var uniqueCode = props.parentUniqueCode;
        var DFDIDString = props.selectedQuestion.DFDID;
        
        /////joining with particlur room
        if(props.selectedQuestion.DFDID)
        {
          
          connection.invoke(
            'Join',
            uniqueCode.toString() + '-' + DFDIDString.toString(),
            `${userType == 'student' ? 2 : 1}`,
            `jwtToken:${jwt}`
          );
        }
      })
      .catch(err =>
        console.log(`Error starting the connection: ${err.toString()}`),
      );
      

    //   // Incoming messages will grow the message log array
    connection.on('newMessage', data => {
      const receivedValue = JSON.parse(JSON.stringify(data));
      var convertedValue = {
        DFQID: receivedValue.dfqid,
        ActualID: receivedValue.actualID,
        DiscussionDetail: receivedValue.discussionDetail,
        DiscussionImage: receivedValue.discussionImage,
        IsHide: receivedValue.isHide,
        PostBy: receivedValue.postBy,
        PostTime: receivedValue.postTime,
        UserType: receivedValue.userType,
        VideoURL: receivedValue.videoURL,
        ImageURL: receivedValue.imageURL,
        DFDID: receivedValue.id,
        DFMID: receivedValue.dfmid
      };
      console.log('new message received->' + JSON.stringify(receivedValue));
      // console.log("ids which are not matching ---");
      
      console.log('convertedValue.DFDIDt-> ', convertedValue.DFDID);
      console.log('convertedValue.UserType-> ', convertedValue.UserType);
      console.log("props.selectedQuestion.IsSelfPost ->", props.selectedQuestion.IsSelfPost);
      console.log("commentIndividual.DFMIDOwner -> " , commentIndividual.DFMIDOwner);
      console.log("commentIndividual.DFMIDOwner -> " , DFMIDOwnerReducer);
      console.log("commentIndividual.DFMID -> " , commentIndividual.DFMID);
      console.log("convertedValue.DFMID ->", convertedValue.DFMID);
      console.log("props.selectedQuestion.DFDID ->", props.selectedQuestion.DFDID)
     
     
     

      if(
        commentIndividual != null &&
        userType === 'student' &&
        convertedValue.UserType == 1 &&
        (props.selectedQuestion.IsSelfPost === DFMIDOwnerReducer) &&
        props.selectedQuestion.IsSelfPost !== convertedValue.DFMID &&
        convertedValue.DFDID === props.selectedQuestion.DFDID
      ) {
        // console.log("sould the posts count to be zero");
        setTotalSelfPost(0);
        // isFacultyMessage = true;
        // console.log("faculty message");
        // console.log(isFacultyMessage);
      } else {
        // isFacultyMessage = false;
      } 

      if (convertedValue.DFDID === props.selectedQuestion.DFDID) {
        insertCommentItem(convertedValue, dispatch)
        }
        setSendingComment(false);
    });
    connection.on('addUser', data => {
      console.log('new message user ' + data);
    });
    connection.on('onError', data => {
      console.log('ERROR=> ' + data);
    });

    // Handle connection closing
    connection.onclose(async () => {
      console.log("on connection close --- ");
      connection.start()
    });

    setConn(connection);
  }, 2000);
  }, []);

  function commentHubData(sendComment, saveComment) {
    console.log('Comment data --->', sendComment);
    setSendingComment(true);
     //Used separate variables to create correct room ID
     
    console.log("save comment comment -- ", saveComment);
    const receivedValue = saveComment;
   
    var convertedValue = {
      DFQID: receivedValue.dfqid || "",
      ActualID: receivedValue.actualID,
      DiscussionDetail: receivedValue.decription,
      DiscussionImage: receivedValue.contentFileURL || "",
      IsHide: false,
      PostBy: profileDetails[0].FirstName || "",
      PostTime: "",
      UserType: receivedValue.userType,
      VideoURL: receivedValue.videoURL || "",
      ImageURL: receivedValue.contentFileURL || "",
      DFDID: receivedValue.dfdID,
      DFMID: receivedValue.dfmID,
    };
    
    convertedValue["ActualID"] = "temp";
    insertCommentItem(convertedValue, dispatch);
    
    ///
     var uniqueCode = props.parentUniqueCode;
     var DFDIDString = props.selectedQuestion.DFDID;
    var roomName = uniqueCode.toString() + '-' + DFDIDString.toString()



    conn
      .invoke('SendMessage', `${roomName}`,`${sendComment}`)
      .then(response => {
        console.log('comment response --->', response);

        // student can send 3 comments continuously then reload comment and hide textinput view
        if(commentIndividual != null && userType === 'student') {
          console.log("initial self post");
          console.log(totalSelfPost);
          setTotalSelfPost(1 + totalSelfPost);
        }
        

        // console.log("before refresh the comments --");
        // console.log(props.selectedQuestion.IsSelfPost === commentIndividual.DFMIDOwner);
        // console.log(totalSelfPost >= maxStudentDoubtCommentCount);

        // if(commentIndividual != null && userType === 'student' &&
        // props.selectedQuestion.IsSelfPost === commentIndividual.DFMIDOwner &&
        // totalSelfPost < maxStudentDoubtCommentCount)
        // {
        //   console.log("refresh the comments --");
        //   fetchCommentData();
        // }
      })
      .catch(err => {
        console.log(err);
      });
  }

  const fetchCommentData = () => {
    if (!isFetching) {
      setIsFetching(true);
    }
    studentDiscussionComments(props.parentUniqueCode, props.selectedQuestion.DFDID, jwt, dispatch).then(() => {
      setIsFetching(false);
    });
  };

  const populateComments = () => {
    const list = [];
    commentList.map(data => {
      var imageUrl = ""
      if(!data.DiscussionImage.includes('https')) {
        imageUrl = data.CloudFrontURL + "/Picture/" +  data.DiscussionImage;
      } else {
        imageUrl = data.DiscussionImage
      }
      
      if (
        userType !== 'student' ||
        userType == 'student'
      )
        return list.push(
          <div className= { data.DFMID === commentIndividual.DFMID ? "member-comment-card" : "question-card"}>
            <div className="question-header">
              <div className="flex-row">
                <Avatar src={data.PostByPicture} alt="user" />
                <div className="user-details">
                  <div className="name">{data.PostBy || 'Unknown'}</div>
                 {(data.PostTime.length ==0) ? <div className="date" style={{ color: "grey", height: 15, width: 15, marginTop: 5}}> <img src={ClockIcon} /> </div>  : <div className="date">{data.PostTime}</div> } 
                </div>
              </div>
              <div className="right-panel">
                {/* Screening/Hidden/Rejected prompt */}
                {(data.IsHide) &&
                data.IsSelfPost &&
                userType === 'student' ? (
                  data.IsReject || data.IsHide ? (
                    data.IsHide ? (
                      <div className="status-label">Hidden</div>
                    ) : (
                      <div className="status-label rejected">Rejected</div>
                    )
                  ) : (
                    <div className="status-label">
                      <img src={LoadingGifIcon} />
                      Screening
                    </div>
                  )
                ) : null}
              </div>
            </div>
            <div className="question-body">
              <div className="desc">{data.DiscussionDetail}</div>
            </div>
            <div className="upload-body">
              {data.DiscussionImage ? (
                <div
                  className="img-container"
                  style={{ backgroundImage: `url(${data.DiscussionImage})` }}
                  onClick={() => {
                    seturlToExpand(imageUrl);
                    setIsImage(true);
                    handleClickOpen();
                  }}
                >
                  <img src={imageUrl} />
                  </div>
              ) : null}
              {data.VideoURL ? (
                <div className="vid-container">
                  <video
                    id="video1"
                    width="100%"
                    onClick={() => {
                      seturlToExpand(data.VideoURL);
                      setIsImage(false);
                      handleClickOpen();
                    }}
                  >
                    <source src={data.VideoURL} type="video/mp4" />
                  </video>
                </div>
              ) : null}
            </div>

            {/* <div className="comments">
              <div
                className="item"
                onClick={() => {
                  likeDislikeComment(2, data.DFQID, jwt, dispatch);
                  studentDiscussionComments(props.parentUniqueCode, props.selectedQuestion.DFDID, jwt, dispatch);
                }}
              >
                <span
                  className="icon"
                  style={data.IsLike ? { color: 'blue' } : {}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.579"
                    height="11.901"
                    viewBox="0 0 10.579 11.901"
                  >
                    <path
                      id="thumbs-up"
                      d="M10.9,5.806c-.088-.235,2.34-2.4.924-4.16-.331-.411-1.455,1.967-3.051,3.043-.881.594-2.93,1.858-2.93,2.557V11.77c0,.841,3.249,1.73,5.718,1.73.9,0,2.216-5.67,2.216-6.571S10.988,6.041,10.9,5.805Zm-5.718.063A1.96,1.96,0,0,0,3.2,7.933v3.205a1.894,1.894,0,0,0,1.983,2c.434,0-.661-.378-.661-1.494V7.428c0-1.169,1.1-1.56.661-1.56Z"
                      transform="translate(-3.2 -1.599)"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                {data.TotalLike} Like
              </div>
              <div
                className="item"
                onClick={() => {
                  likeDislikeComment(3, data.DFQID, jwt, dispatch);
                  studentDiscussionComments(props.parentUniqueCode, props.selectedQuestion.DFDID, jwt, dispatch);
                }}
              >
                <span
                  className="icon"
                  style={data.IsDisLike ? { color: 'red' } : {}}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.579"
                    height="11.901"
                    viewBox="0 0 10.579 11.901"
                  >
                    <path
                      id="thumbs-down"
                      d="M10.9,9.293c-.088.235,2.34,2.4.924,4.16-.331.411-1.455-1.967-3.051-3.043-.881-.594-2.93-1.858-2.93-2.557V3.329c0-.841,3.249-1.73,5.718-1.73l1.812,4.337.4,2.234c0,.9-2.791.888-2.877,1.124ZM5.183,9.23A1.96,1.96,0,0,1,3.2,7.165V3.96a1.894,1.894,0,0,1,1.983-2c.434,0-.661.378-.661,1.494V7.67c0,1.169,1.1,1.56.661,1.56Z"
                      transform="translate(-3.2 -1.599)"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                {data.TotalDislike} Dislike
              </div>
            </div> */}
          </div>
        );
    });
    return <>{list} </>;
  };

  const onCameraSuccess = async (e, dataType) => {
    const file = Array.from(e.target.files);
    if (!file[0].type.includes('image')) {
      return dispatch(
        openSnackBar({
          message: 'Unsupported file format',
          severity: 'error'
        })
      );
    }
    if (file[0].size > 512000) {
      return dispatch(
        openSnackBar({
          message: 'The file is too large. Max allowed size is 512kb',
          severity: 'error'
        })
      );
    }
    setIsImageUploading(true);
    const formData = new FormData();
    const dataURI = await fileToDataUri(file[0]);
    const blobFile = await dataURLtoBlob(dataURI);
    formData.append('user_picture', blobFile, 'user_picture.jpg');
    console.log('before fetch');
    await imagePost(
      userType === 'student'
        ? 'api/uploaddoubtimage'
        : dataType === 'image'
        ? 'api/facultyuploaddoubtimage'
        : 'api/submitvideo',
      jwt,
      formData
    )
      .then(resp => {
        console.log('after fetch', resp);
        if (resp.error && !resp.data) {
          //   dispatch(
          //     openSnackBar({
          //       message: JSON.parse(resp.data).message,
          //       severity: 'error'
          //     })
          //   );
          console.log('We are in error condition');
          setFilePath('');
          return setIsImageUploading(false);
        }
        console.log('before check');
        setIsImageUploading(false);
        if (dataType === 'image') {
          console.log("image file path ---");
          console.log(resp.data);
          setFilePath(
            // `https://dc.allenbpms.in/UploadWhizkids6020FF09/document/${resp.data}`
            URL.createObjectURL(file[0])
          );
          setState({
            ...state,
            image: resp.data
            // image: URL.createObjectURL(file[0])
          });
        } else {
          console.log('datatype video');
          setState({
            ...state,
            video: resp.data
          });
        }
      })
      .catch(err => {
        console.log('Error -', err);
        setIsImageUploading(false);
        setState({
          ...state,
          image: '',
          video: ''
        });
        setFilePath('');
      });
  };

  const fileToDataUri = file =>
    new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = event => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const onFormSubmit = async () => {

    var  sendComentData = {
      decription: state.desc.replace(/^\s+|\s+$/gm, ''),
      imageURL: state.image,
      videoURL: null,
      audioURL: '',
      contentFileURL: '',
      userType: 2,
      forumID: props.parentForumId,
      // doubtID :props.questionId,
      userID:  userType === 'student' ? 2 : 1,
      jwtToken: jwt,
      dfmID: commentIndividual.DFMID,
      dfdID: props.selectedQuestion.DFDID,
    };

    console.log("image url --");
    console.log(state.image)
    
    if((sendComentData.decription || "").length > 0 || (state.image != null && state.image.length > 0)) {
      await commentHubData(JSON.stringify(sendComentData), sendComentData);

    // insertCommentItem
    setState({
      ...state,
      desc: '',
      image: '',
      isFetching: false
    });
    setFilePath('');
    }
    
  };

  const commentSubmitForm = () => {
    console.log("total posts count are ");
    console.log(totalSelfPost)
    return (
      <div className="message-box">
        {filePath || isImageUploading ? (
          <div className="upload-image-container">
            {isImageUploading ? (
              <div>...Loading</div>
            ) : (
              <div className="image">
                <img src={filePath} />
                <span
                  className="close"
                  onClick={() => {
                    setFilePath('');
                    setState({
                      ...state,
                      image: '',
                      isFetching: false
                    });
                  }}
                >
                  <CloseIcon />
                </span>
              </div>
            )}
          </div>
        ) : null}
        <div className="chat">
          <textarea
            id="desc"
            maxLength="600"
            className="form-control"
            placeholder={
              userType === 'student'
                ? 'Add your comment'
                : 'Enter your question description'
            }
            value={state.desc}
            onChange={e =>
              setState({
                ...state,
                desc: e.target.value
              })
            }
          >
            {state.desc}
          </textarea>

          <div className="image-upload">
            <label htmlFor="file-input">
              <img src={AttachIcon} />
            </label>

            <input
              id="file-input"
              type="file"
              accept="image/*"
              onChange={e => onCameraSuccess(e, 'image')}
            />
          </div>
          {(isSendingComment) ? <img src={LoadingGifIcon} /> :
          <IconButton onClick={() => onFormSubmit()}>
            <img src={SendIcon} />
            {/* {userType === 'student' ? 'Submit Doubt' : 'Submit Question'} */}
          </IconButton>}
        </div>
      </div>
    );
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
const getCommentBox = () => {
  console.log("total self postststststs 000000-------");
  console.log(totalSelfPost);
  console.log("commentIndividual.DFMIDOwner -> " , commentIndividual.DFMIDOwner);
  // console.log(isFacultyMessage);
  
  return (
    (userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 1 && get(commentIndividual, 'IsPostAllowed', false) &&  totalSelfPost < maxStudentDoubtCommentCount && !isFetching) ||
        (userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 2 && props.selectedQuestion.IsSelfPost === commentIndividual.DFMIDOwner &&  totalSelfPost < maxStudentDoubtCommentCount && !isFetching) ? (
          commentSubmitForm()
        ) : (
            (userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 1 && get(commentIndividual, 'IsPostAllowed', false) && totalSelfPost >= maxStudentDoubtCommentCount && !isFetching) ||
            (userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 2 && props.selectedQuestion.IsSelfPost === commentIndividual.DFMIDOwner && totalSelfPost >= maxStudentDoubtCommentCount && !isFetching)
            ? showMaxCommentLimitMessage()
            : null
        )
  )
}
  const showMaxCommentLimitMessage = () => {

    console.log("show max comment limit message")

    console.log((userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 1 && get(commentIndividual, 'IsPostAllowed', false) && (initialTotalSelfPost === 0 ? initialTotalSelfPost : totalSelfPost) < maxStudentDoubtCommentCount && !isFetching))
    console.log((userType === 'student' && get(commentIndividual, 'OwnerType', 0) == 2 && props.selectedQuestion.IsSelfPost === commentIndividual.DFMIDOwner && (initialTotalSelfPost === 0 ? initialTotalSelfPost : totalSelfPost) < maxStudentDoubtCommentCount && !isFetching))
    return (
      <div style={{margin:'20px',}}>
          <label style={{alignContent:'start', color:'red'}}>
            Maximum 3 doubts allowed at a time. Kindly wait for your teacher to respond.
            </label>            
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="doubt-details popup-details">
        <PerfectScrollbar>
          <div
            className={ props.selectedQuestion.DFMID === commentIndividual.DFMID 
              ? props.selectedQuestion.IsHide ? `self-question-card ${'hidden'}` : `self-question-card`
              : props.selectedQuestion.IsHide ? `question-card ${'hidden'}` : `question-card`
            }
          >
            <div className="question-header">
              <div className="flex-row">
                <Avatar src={props.selectedQuestion.PostByPicture} alt="user" />
                <div className="user-details">
                  <div className="name">
                    {props.selectedQuestion.MemberFullName || 'Unknown'}
                  </div>
                  <div className="date">{props.selectedQuestion.PostTime}</div>
                </div>
              </div>
              <div className="right-panel">
                {/* Screening/Hidden/Rejected prompt */}

                {/* <>
                  {(
                    props.selectedQuestion.IsHide) &&
                    props.selectedQuestion.IsSelfPost === get(commentIndividual, 'OwnerType', 0) &&
                    props.selectedQuestion.userType === 'student' ? (
                    props.selectedQuestion.IsHide ? (
                    props.selectedQuestion.IsHide ? (
                        <div className="status-label">Hidden</div>
                      ) : (
                        <div className="status-label rejected">Rejected</div>
                      )
                    ) : (
                      <div className="status-label">
                        <img src={LoadingGifIcon} />
                        Screening
                      </div>
                    )
                  ) : !commentIndividual.IsClose ? (
                    <div className="status-label open">Open</div>
                  ) : (
                    <div className="status-label closed">Closed</div>
                  )}
                </> */}
              </div>
            </div>
            <div className="question-body">
              <div className="title">
                {props.selectedQuestion.QuestionTitle}
              </div>
              <div className="desc">
                {props.selectedQuestion.QuestionDetail}
              </div>
            </div>
            <div className="upload-body">
              {props.selectedQuestion.QuestionImage ? (
                <div
                  className="img-container"
                  style={{
                    backgroundImage: `url(${props.selectedQuestion.QuestionImage})`
                  }}
                  onClick={() => {
                    seturlToExpand(props.selectedQuestion.QuestionImage);
                    setIsImage(true);
                    handleClickOpen();
                  }}
                />
              ) : null}
              {props.selectedQuestion.VideoURL ? (
                <div
                  className="vid-container"
                  onClick={() => {
                    seturlToExpand(props.selectedQuestion.VideoURL);
                    setIsImage(false);
                    handleClickOpen();
                  }}
                >
                  <video id="video1" width="100%">
                    <source
                      src={props.selectedQuestion.VideoURL}
                      type="video/mp4"
                    />
                  </video>
                </div>
              ) : null}
            </div>
          </div>
          <div className="comments-list">
            {
              commentList && commentList.length > 0
              ? populateComments()
              : null 
            }
          </div>
          <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={'sm'}
            className="simple-dialog"
            
          >
            <span className="popup-close" onClick={handleClose}>
              <CloseIcon />
            </span>
            <div className="embed-responsive embed-responsive-16by9" >
              {isImage ? (
                <div className="embed-responsive-item" >
                  <center>
                  <img src={urlToExpand} />
                  </center>
                </div>
              ) : (
                <video
                  className="embed-responsive-item"
                  height="315"
                  width="100%"
                  src={urlToExpand}
                  allowFullScreen
                  controls
                  controlsList="nodownload"
                  disablePictureInPicture
                >
                  <source src={urlToExpand} type="video/mp4" />
                </video>
              )}
            </div>
          </Dialog>
          {/* <div ref={messagesEndRef} /> */}
          <AlwaysScrollToBottom />
        </PerfectScrollbar>
      </div>
      {
      getCommentBox()
      }
        

    </React.Fragment>
  );
}

DoubtComments.propTypes = {
  UniqueCode: PropTypes.string,
  selectedQuestion: PropTypes.object,
  parentUniqueCode: PropTypes.string,
  parentForumId : PropTypes.number,
  questionId : PropTypes.number,
  IsClose: PropTypes.bool
};
